// types
import { User } from '../../../../@types';

// l18n
import { TFunction } from 'i18next';

// mui
import { Typography } from '@mui/material';

// table
import { TableHeader } from '../../../ui/Table/Table';

// ui
import { Time } from '../../../ui/Time/Time';
import { UserAvatar } from '../../../ui/UserAvatar/UserAvatar';

// props
export interface GetHeadersProps {
	t: TFunction<'translation', undefined>;
}

export const getHeaders = ({ t }: GetHeadersProps): TableHeader[] => {
	return [
		{
			label: t('user'),
			render: (user: User) => {
				return <UserAvatar user={user} />;
			},
			value: 'user',
		},
		{
			label: t('created'),
			render: (created: string) => {
				return <Time date={new Date(created)} />;
			},
			value: 'created',
		},
		{
			label: t('comment'),
			render: (comment: string) => {
				return <Typography>{comment}</Typography>;
			},
			value: 'comment',
		},
	];
};
